var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import has from "lodash/has";
import { doesMatchSlot, doesOverlapSlot } from "./helpers";
var BookedEventsHandler = /** @class */ (function () {
    function BookedEventsHandler(ranges, bookersCount) {
        this.ranges = ranges;
        this.bookersCount = bookersCount;
    }
    BookedEventsHandler.prototype.getStatus = function (from, to, max_quantity) {
        var result = {
            data: {},
            debug: { from: from, to: to },
            isAvailable: true,
            name: this.constructor.name
        };
        for (var _i = 0, _a = this.ranges; _i < _a.length; _i++) {
            var range = _a[_i];
            if (doesMatchSlot(from, to, range)) {
                var quantity_left = max_quantity - range.data.booking_count, isAvailable = true;
                if (has(result.data, "quantity_left")) {
                    quantity_left = Math.min(quantity_left, result.data.quantity_left);
                }
                isAvailable = quantity_left > 0 && this.bookersCount <= quantity_left;
                result = {
                    isAvailable: isAvailable,
                    from: from, to: to,
                    data: __assign(__assign({}, range.data), { quantity_left: quantity_left }),
                    name: this.constructor.name
                };
                if (!isAvailable) {
                    return result;
                }
                continue;
            }
            if (doesOverlapSlot(from, to, range.from, range.to)) {
                var quantity_left = max_quantity - range.data.booking_count, isAvailable = true;
                if (has(result.data, "quantity_left")) {
                    quantity_left = Math.min(quantity_left, result.data.quantity_left);
                }
                isAvailable = quantity_left > 0 && this.bookersCount <= quantity_left;
                result = {
                    isAvailable: isAvailable,
                    from: from, to: to,
                    data: __assign(__assign({}, range.data), { partial: true, quantity_left: quantity_left }),
                    name: this.constructor.name
                };
                if (!isAvailable) {
                    return result;
                }
                continue;
            }
        }
        return result;
    };
    return BookedEventsHandler;
}());
export { BookedEventsHandler };
